<template>
  <div id="column-chart">
    <apexchart
      type="line"
      height="350"
      :options="chartOptions"
      :series="series"
      class="has-padding-1"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import GeneralService from "@/services/GeneralService";

export default {
  name: "column-chart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    costSectionTotals: {
      type: Array,
      default: () => [],
    },
    optimalConditions: {
      type: Array,
      default: () => null,
    },
    primaryColors: {
      type: Array,
      default: () => ["#008FFB", "#32CD32"],
    },
    finalTotal: {
      type: Number,
      default: 0,
    },
    categories: {
      type: Array,
      default: () => [
        "Prevention",
        "Appraisal",
        "Internal Failure",
        "External Failure",
        "Other Types of Waste",
      ],
    },
  },
  data() {
    return {
      bannerColors: [
        "blue",
        "light-blue",
        "orange",
        "purple",
        "red",
        "blue",
        "light-blue",
      ],
    };
  },
  computed: {
    series() {
      return this.formattedSeries;
    },
    chartOptions() {
      return {
        annotations: {
          yaxis: this.optimalConditionsAverage,
        },
        chart: {
          height: 350,
          type: "bar",
          stacked: false,
          events: {},
        },
        colors: this.primaryColors,
        stroke: {
          width: [0, 1],
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: this.formattedYAxis,
        tooltip: this.formattedTooltip,
      };
    },
    formattedYAxis() {
      return [
        {
          title: {
            text: "Cost of Defect ($)"
          },
          labels: {
            formatter: function(y) {
              return GeneralService.dollarFormatted(y.toFixed(0));
            },
          },
        },
      ];
    },
    formattedSeries() {
      return [
        {
          name: "Total Costs",
          type: "column",
          data: this.costSectionTotals,
        },
        {
          name: "Optimal Conditions",
          type: "column",
          data: this.optimalConditions,
        },
      ];
    },
    formattedTooltip() {
      return {
        y: {
          formatter: function(val) {
            return "$ " + GeneralService.dollarFormatted(val.toFixed(0));
          },
        },
      };
    },
    optimalConditionsAverage() {
      const average = this.finalTotal / 5;
      return [
        {
          y: average,
          borderColor: "#FF4560",
          label: {
            borderColor: "#FF4560",
            style: {
              color: "#fff",
              background: "#FF4560",
            },
            text: "Average Total Costs",
          },
        },
      ];
    },
  },
};
</script>